export default "__VITE_ASSET__DWaDfvcQ__"